import { useState } from 'react';
import { getUserLocale, SupportedLocale } from './config';

// Export a hook to change locale
export function useLocale() {
  const [locale, setLocale] = useState<SupportedLocale>(getUserLocale());

  return {
    locale,
    setLocale,
  };
}
